"use client";

import React, { useCallback } from "react";
import { useModal } from "./ModalProvider";
import { useProjectMediaGalleriesState } from "@/store/store";
export default function SwiperWrapper({
  children,
  imageId,
  onOpen
}) {
  const {
    openModal
  } = useModal();
  const {
    projectMediaGalleries
  } = useProjectMediaGalleriesState();
  const findImageIndexById = useCallback(imageId_0 => {
    if (!imageId_0 || !projectMediaGalleries?.data?.length) return null;
    const index = projectMediaGalleries.data.findIndex(image => image.id === imageId_0);
    return index >= 0 ? index : 0;
  }, [projectMediaGalleries?.data]);
  const handleClick = () => {
    if (imageId !== undefined) {
      onOpen?.();
      const index_0 = findImageIndexById(imageId);
      openModal(index_0);
    }
  };
  return React.cloneElement(children, {
    onClick: handleClick,
    ...children.props
  });
}